import React, { useState } from "react";
import axios from "axios";
import "../css/DisapprovePopup.css";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "./LoadingOverlay";
import PopupModal from "./PopupModal";
import { faCheckCircle, faTimesCircle, faBan, faHand, faFileExcel   } from '@fortawesome/free-solid-svg-icons';



const DisapproveButton = ({ requisitionId }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [reason, setReason] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);  

  const navigate = useNavigate();

  const handleDisapproveClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setReason("");
    navigate('/staff-requisitions');
  };

  const handleModalClose = () => {
        
    window.location.reload();
  };

  const handleErrorModalClose = () => {
    setShowErrorModal(false);
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
  };

  const handleSendDisapproval = async () => {
    if (!reason.trim()) {
      alert("Please enter a reason for disapproval.");
      return;
    }

    try {
      setIsSubmitting(true);
      const token = localStorage.getItem("token"); 

      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/requisition/disapprove/${requisitionId}`,
        { reason: reason.trim() },
        {
          headers: { 
            Authorization: `Bearer ${token}` 
          }
        }
      );
      
      setShowModal(true); 
    } catch (error) {
      console.error("Error disapproving requisition:", error);
      setShowErrorModal(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
    <LoadingOverlay isVisible={isSubmitting} />
      
      <br />
      <button className="disapprove-button" onClick={handleDisapproveClick}>
        Disapprove <i className="fas fa-times"></i>
      </button>
      <PopupModal
        title="Disapproved"
        titleStyle="success-title"
        message="This requisition has been disapproved."
        icon={faFileExcel}
        iconBorder="popup-modal-icon"
        isVisible={showModal}
        confirmText="OK"
        onConfirm={() => {
          setShowModal(false);
          navigate("/notifications");
          }}
          onClose={() => {
            setShowModal(false);
            navigate("/notifications");
          }}
      />
      <PopupModal
        title="Error"
        titleStyle = "error-title"
        message="Disapproving wasNOT successful."
        icon={faTimesCircle}
        isVisible={showErrorModal}
        onClose={handleErrorModalClose}
        iconBorder="popup-modal-icon"
      />  
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup">
            <label className="popup-label">Reason for Disapproval</label>
            <input
              type="text"
              className="popup-input"
              value={reason}
              onChange={handleReasonChange}
            />
            <button className="btn btn-primary" onClick={handleSendDisapproval} disabled={isSubmitting}>
              {isSubmitting ? "Sending..." : "Send"}
            </button>
            <button className="btn btn-primary cancel-button" onClick={handleClosePopup}>
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DisapproveButton;
